/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDefinitionDtoDefinitionLabel } from './CreateDefinitionDtoDefinitionLabel';
import {
    CreateDefinitionDtoDefinitionLabelFromJSON,
    CreateDefinitionDtoDefinitionLabelFromJSONTyped,
    CreateDefinitionDtoDefinitionLabelToJSON,
} from './CreateDefinitionDtoDefinitionLabel';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { CreateDefinitionParameterDto } from './CreateDefinitionParameterDto';
import {
    CreateDefinitionParameterDtoFromJSON,
    CreateDefinitionParameterDtoFromJSONTyped,
    CreateDefinitionParameterDtoToJSON,
} from './CreateDefinitionParameterDto';
import type { CreateDefinitionParameterValueSetDto } from './CreateDefinitionParameterValueSetDto';
import {
    CreateDefinitionParameterValueSetDtoFromJSON,
    CreateDefinitionParameterValueSetDtoFromJSONTyped,
    CreateDefinitionParameterValueSetDtoToJSON,
} from './CreateDefinitionParameterValueSetDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateDefinitionDto
 */
export interface CreateDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionDto
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionDto
     */
    description?: string | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof CreateDefinitionDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {Array<CreateDefinitionParameterDto>}
     * @memberof CreateDefinitionDto
     */
    definitionParameters?: Array<CreateDefinitionParameterDto> | null;
    /**
     * 
     * @type {Array<CreateDefinitionParameterValueSetDto>}
     * @memberof CreateDefinitionDto
     */
    definitionParameterValueSets?: Array<CreateDefinitionParameterValueSetDto> | null;
    /**
     * 
     * @type {CreateDefinitionDtoDefinitionLabel}
     * @memberof CreateDefinitionDto
     */
    definitionLabel?: CreateDefinitionDtoDefinitionLabel | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionDto
     */
    unitId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionDto
     */
    protocolId?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateDefinitionDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDefinitionDto
     */
    $type?: CreateDefinitionDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDefinitionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDefinitionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateDefinitionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDefinitionDtoTypeEnum = typeof CreateDefinitionDtoTypeEnum[keyof typeof CreateDefinitionDtoTypeEnum];


/**
 * Check if a given object implements the CreateDefinitionDto interface.
 */
export function instanceOfCreateDefinitionDto(value?: unknown): value is CreateDefinitionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDefinitionDtoTypeEnum)[0];
}

export function CreateDefinitionDtoFromJSON(json: any): CreateDefinitionDto {
    return CreateDefinitionDtoFromJSONTyped(json, false);
}

export function CreateDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'valueType': !exists(json, 'valueType') ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'definitionParameters': !exists(json, 'definitionParameters') ? undefined : (json['definitionParameters'] === null ? null : (json['definitionParameters'] as Array<any>).map(CreateDefinitionParameterDtoFromJSON)),
        'definitionParameterValueSets': !exists(json, 'definitionParameterValueSets') ? undefined : (json['definitionParameterValueSets'] === null ? null : (json['definitionParameterValueSets'] as Array<any>).map(CreateDefinitionParameterValueSetDtoFromJSON)),
        'definitionLabel': !exists(json, 'definitionLabel') ? undefined : CreateDefinitionDtoDefinitionLabelFromJSON(json['definitionLabel']),
        'unitId': !exists(json, 'unitId') ? undefined : json['unitId'],
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateDefinitionDtoToJSON(value?: CreateDefinitionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'valueType': CreateDefinitionDtoValueTypeToJSON(value.valueType),
        'definitionParameters': value.definitionParameters === undefined ? undefined : (value.definitionParameters === null ? null : (value.definitionParameters as Array<any>).map(CreateDefinitionParameterDtoToJSON)),
        'definitionParameterValueSets': value.definitionParameterValueSets === undefined ? undefined : (value.definitionParameterValueSets === null ? null : (value.definitionParameterValueSets as Array<any>).map(CreateDefinitionParameterValueSetDtoToJSON)),
        'definitionLabel': CreateDefinitionDtoDefinitionLabelToJSON(value.definitionLabel),
        'unitId': value.unitId,
        'protocolId': value.protocolId,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value.$type,
    });
}

